import React from "react";
import "./WhyRejuvenate.css";

// Import your clinic photos here
import clinicReception from "../assets/clinic.jpg";
import consultationImg from "../assets/clinic2.jpg";

function WhyRejuvenate() {
  return (
    <section className="why-rejuvenate-section">
      <div className="why-rejuvenate-container">
        
        {/* Left Column: Image Collage & Stat Card */}
        <div className="left-collage">
          {/* Main Large Interior View */}
          <div className="main-image-card">
            <img src={clinicReception} alt="Rejuvenate Clinic Interior" />
          </div>

          {/* Bottom Row: Consultation Image + Stat Box */}
          <div className="collage-bottom-row">
            <div className="small-image-card">
              <img src={consultationImg} alt="Practitioner Consultation" />
            </div>

            <div className="stat-card">
              <span className="stat-number">100%</span>
              <span className="stat-text">BESPOKE TREATMENT PLANS</span>
            </div>
          </div>
        </div>

        {/* Right Column: Content & Key Benefits */}
        <div className="right-content">
          <p className="sub-heading">— WHY REJUVENATE</p>
          <h2 className="main-heading">
            Redefining beauty <br />
            with care & expertise
          </h2>

          <p className="intro-text">
            Rejuvenate is a boutique aesthetics and skincare clinic in Milton Keynes.
            We combine clinical technology with a genuinely calm, unhurried experience — 
            so you leave feeling looked after, not processed.
          </p>

          {/* Key Value Points */}
          <div className="value-points">
            <div className="point-item">
              <h3>Fully qualified & insured</h3>
              <p>
                Every treatment is carried out by experienced, accredited practitioners using medical-grade products.
              </p>
            </div>

            <div className="point-item">
              <h3>Honest consultations</h3>
              <p>
                We will tell you if a treatment is not right for you. Advice first, always — never a hard sell.
              </p>
            </div>

            <div className="point-item">
              <h3>Results that look like you</h3>
              <p>
                Subtle, natural enhancement designed around your features, skin type and long-term skin health.
              </p>
            </div>
          </div>

          <a href="#contact" className="meet-btn">
            MEET YOUR PRACTITIONER
          </a>
        </div>

      </div>
    </section>
  );
}

export default WhyRejuvenate;